import { memo, useCallback, useState } from 'react';

import { Button, Group, Pagination, ScrollArea, Table, Text } from '@mantine/core';

import ObjectTypeForm from '@/components/object-type-form/object-type-form';
import ObjectTypesItem from '@/components/object-types-item/object-types-item';

import { useDeleteTypeMutation, useGetTypesQuery } from '@/api/booking-object-types';

import { Type } from '@/types/object';

import { chunk } from '@/shared/helpers/utils';
import { LayoutRow } from '@/shared/uikit/layouts/LayoutRow';

function ObjectTypes() {
	const { data: objectTypes } = useGetTypesQuery('dictionary');

	const [objectType, setObjectType] = useState<Type | null>(null);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [activePage, setPage] = useState(1);

	const handleEdit = (item: Type) => {
		setObjectType(item);
		setIsModalOpen(true);
	};

	const handleClose = () => {
		setObjectType(null);
		setIsModalOpen(false);
	};

	const [deleteType] = useDeleteTypeMutation();

	const handleDelete = useCallback(
		async (id: number) => {
			await deleteType(id);
		},
		[deleteType],
	);

	const chunked = chunk(
		objectTypes?.objects?.filter((objectType) => !objectType.is_deleted) ?? [],
		10,
	);

	const rows = chunked[activePage - 1]?.map((elem) => (
		<ObjectTypesItem
			key={elem.id}
			objectType={elem}
			handleEdit={handleEdit}
			handleDelete={handleDelete}
		/>
	));

	return (
		<>
			<LayoutRow
				title={{
					title: { children: 'Типы объектов', size: 'h4', fw: 800 },
				}}
				type="once"
				style={{ height: 'calc(100vh - 116px)' }}
			>
				<Group>
					<Button
						variant="filled"
						radius="lg"
						onClick={() => {
							setIsModalOpen(true);
						}}
					>
						<Text fw={500}>Добавить тип объекта</Text>
					</Button>
				</Group>
				<ScrollArea h={'100vh'} pr={'md'} scrollbarSize={12} offsetScrollbars>
					<Table verticalSpacing="md" stickyHeader>
						<Table.Thead>
							<Table.Tr>
								<Table.Th>
									<Text size="md" c="dimmed">
										Название
									</Text>
								</Table.Th>
								<Table.Th>
									<Text size="md" c="dimmed">
										Описание
									</Text>
								</Table.Th>
								<Table.Th>
									<Text size="md" c="dimmed">
										Группа
									</Text>
								</Table.Th>
								<Table.Th>
									<Text size="md" c="dimmed">
										ID
									</Text>
								</Table.Th>
								<Table.Th ta="center">
									<Text size="md" c="dimmed">
										Действия
									</Text>
								</Table.Th>
							</Table.Tr>
						</Table.Thead>
						<Table.Tbody>{rows}</Table.Tbody>
					</Table>
				</ScrollArea>
				<Pagination total={chunked.length} value={activePage} onChange={setPage} mt="sm" />
			</LayoutRow>
			<ObjectTypeForm
				isOpen={isModalOpen}
				setIsOpen={setIsModalOpen}
				objectType={objectType}
				handleClose={handleClose}
			/>
		</>
	);
}

export default memo(ObjectTypes);
